import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * PATCH /system/user/{id}；必含 updatedAt；不可送 password。
 * @see docs/API_SYSTEM_USER.md
 */
export async function updateUser(id, payload) {
  const body = { ...(payload ?? {}) };
  delete body.password;
  delete body.account;
  delete body.accountNo;
  const { data: raw } = await request.patch(
    `/system/user/${id}`,
    keysToSnake(body),
  );
  return parseVer4DetailResponse(raw);
}
